import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "graph-container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "graph-container__loading"
}
const _hoisted_4 = { class: "graph-container__actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BarChart = _resolveComponent("BarChart")!
  const _component_AttensiLoadingSpinner = _resolveComponent("AttensiLoadingSpinner")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_ReportDownloadButton = _resolveComponent("ReportDownloadButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.loadingData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "graph-container__header" }, [
            _createElementVNode("div", { class: "graph-container__subheadings" }),
            _createElementVNode("div", { class: "graph-container__type-selection" })
          ], -1 /* CACHED */)),
          _createVNode(_component_Pagination, {
            "no-of-items": _ctx.totalPageCount,
            "current-page": _ctx.currentPage,
            "items-per-page": _ctx.itemsPerPage,
            onChangePage: _ctx.changePage
          }, {
            default: _withCtx(() => [
              (_ctx.queryData)
                ? (_openBlock(), _createBlock(_component_BarChart, {
                    key: 0,
                    "report-data": _ctx.queryData,
                    class: "graph-container__graph"
                  }, null, 8 /* PROPS */, ["report-data"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_AttensiLoadingSpinner)
                  ]))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["no-of-items", "current-page", "items-per-page", "onChangePage"])
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_ReportDownloadButton, {
        report: _ctx.report,
        text: 'Download'
      }, null, 8 /* PROPS */, ["report"])
    ])
  ]))
}